<template>
  <layout-master>
    <router-view />
  </layout-master>
</template>

<script>
import LayoutMaster from '@/views/home/layouts/LayoutMaster.vue'
import { getToken } from '@/auth/utils'

export default {
  components: {
    LayoutMaster,
  },
  data() {
    return {
    }
  },
  beforeCreate() {
    this.$store.commit('app/UPDATE_PAGE_LOADING', true);
    if (getToken()) {
      this.$store.dispatch('settings/getListByGroup', { group: 'home' }).then((res) => {
        if (res.status === 200) {
          this.$store.commit('app/UPDATE_PAGE_LOADING', false);
          this.$store.commit('app/UPDATE_SETTING', { home: res.data.data });
        }
      })
    }
  },
  methods: {

  },
}
</script>
